import { isSameDay } from 'date-fns';
import { ClinicsListProps } from 'screens/ExploreClinics/props';
import { getFormattedDateHeader } from 'screens/ExploreClinics/utils';
import MarketplaceEmptyPlaceholder from 'components/MarketplaceEmptyPlaceholder';
import classNames from 'styles/utils/classNames';
// Import this utility
import ClinicCard from './ClinicCard';
import FeaturedClinics from './FeaturedClinics';
import ClinicLoadingSkeleton from '../ClinicLoadingSkeleton';

const ClinicsList: React.FC<ClinicsListProps> = ({
  list,
  featuredClinics,
  loading,
  called,
  setListHoveredClinicId,
  listHoveredClinicId,
  setListHoveredVenueId,
  onClinicDetail,
  dates,
  selectedDate,
  handleClearAllFilters,
}) => {
  return loading || !called ? (
    <ClinicLoadingSkeleton />
  ) : dates?.length > 0 || featuredClinics.length > 0 ? (
    <div className="flex flex-col px-4 pb-4 lg:px-6">
      <FeaturedClinics
        featured={featuredClinics}
        listHoveredClinicId={listHoveredClinicId}
        setListHoveredClinicId={setListHoveredClinicId}
        setListHoveredVenueId={setListHoveredVenueId}
        onClinicDetail={onClinicDetail}
      />
      {dates?.map((date, dateIndex) => {
        const { formattedDate, formattedYear } = getFormattedDateHeader(date);

        return (
          <div key={date}>
            <div className={classNames('mb-3 px-0  sm:px-5', dateIndex > 0 && 'mt-6')}>
              <span className="typography-product-subheading">
                {formattedDate} <span className="text-color-brand-primary">&bull;</span>{' '}
                {formattedYear}
              </span>
            </div>

            {list[date].map((clinic) => (
              <ClinicCard
                clinic={clinic}
                key={clinic.id}
                setListHoveredClinicId={setListHoveredClinicId}
                listHoveredClinicId={listHoveredClinicId}
                setListHoveredVenueId={setListHoveredVenueId}
                onClinicDetail={onClinicDetail}
              />
            ))}
          </div>
        );
      })}
    </div>
  ) : (
    <MarketplaceEmptyPlaceholder
      title="Hang tight! We'll have clinics in this area soon!"
      onClearFilters={handleClearAllFilters}
    />
  );
};

export default ClinicsList;
